module.exports = __webpack_public_path__ + "static/topBlob-1d8b69f77ed00449f13a42a5e1071366.png";